<template>
  <div class="PageCta">
    <SanityImage v-if="content.image" :asset="content.image.asset" class="image" />
    <div class="text">
      <div v-if="content.label" class="label">{{ content.label }}</div>
      <div class="title">{{ content.title }}</div>
    </div>
    <div v-if="content.ctaText && content.ctaAction">
      <CtaButton v-if="content.ctaAction === 'showPopover'"
        :text="content.ctaText"
        @click="showPopover"
        class="--bright-blue"
      />
      <CtaButton v-else
        :text="content.ctaText"
        :action="content.ctaAction === 'linkToPage' ? content.urlOrPath : content.ctaAction"
        class="--bright-blue"
      />
    </div>
  </div>
</template>

<script>
// Note: should be instantiated with either the '--sidebar' or '--mid-page' class to
// indicate the context as they have different styles applied.
export default {
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    showPopover: {
      type: Function,
    },
  },
}
</script>

<style scoped>

.PageCta {
  background-color: var(--bg-color-dark-blue);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: var(--spacing-6);
}

.PageCta.--mid-page {
  padding: var(--spacing-8);
}

.PageCta.--sidebar {
  padding: var(--spacing-6);
}

.PageCta.--mid-page .image {
  max-width: 8rem;
}

.PageCta.--sidebar .image {
  max-width: 10rem;
}

.label {
  font-weight: 600;
  text-transform: uppercase;
  color: var(--brand-color);
}

.PageCta.--mid-page .label {
  font-size: var(--font-size-1);
}

.PageCta.--sidebar .label {
  font-size: var(--font-size-2);
}

.title {
  font-weight: 600;
  line-height: 1.2;
  color: var(--text-color-white);
}

.PageCta.--mid-page .title {
  font-size: var(--font-size-4);
}

.PageCta.--sidebar .title {
  font-size: var(--font-size-5);
}

@media (--screen-md) {

  .PageCta.--mid-page {
    flex-direction: row;
    align-items: center;
    column-gap: var(--spacing-8);
  }

  .PageCta.--mid-page .text {
    flex-grow: 1
  }
}
</style>
